import styled from 'styled-components';
import { TextField } from '@mui/material';
import { colors } from '../modules/constants/colors';

export const StyledTextField = styled(TextField)`
  .MuiOutlinedInput-root {
    border-radius: 12px;
    font-family: "Montserrat", sans-serif;

    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: ${colors.primary};
    }

    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: ${colors.primary};
    }
  }

  .MuiInputLabel-root {
    font-family: "Montserrat", sans-serif;
    
    &.Mui-focused {
      color: ${colors.primary};
    }
  }

  .MuiFormHelperText-root {
    font-family: "Montserrat", sans-serif;
  }
`;
